import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import api, { getErrorMessage } from '../api/client';
import { useAuth } from '../context/AuthContext';
import PasswordInput from '../components/PasswordInput';
import { Spinner } from '../components/StateBlock';

const Login = () => {
  const { login, sessionMessage, clearSessionMessage } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const successMessage = location.state?.successMessage || '';
  // Volta para a página que exigiu login (se houver).
  const redirectTo = location.state?.from || '/listas';

  useEffect(() => () => clearSessionMessage(), [clearSessionMessage]);

  const onSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setIsPending(true);

    try {
      const { data } = await api.post('/users/login', { email, senha });
      login(data.token);
      navigate(redirectTo, { replace: true });
    } catch (error) {
      setErrorMessage(
        getErrorMessage(error, 'Falha no login. Verifique suas credenciais.')
      );
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="page">
      <div className="auth-layout">
        <section className="surface-card card-pad auth-side">
          <span className="eyebrow">Acesso</span>
          <h1 className="page-title">Entre e continue de onde parou.</h1>
          <p className="section-copy">
            Suas listas, categorias e totais ficam salvos e sincronizados entre o
            celular e o computador.
          </p>
          <ul className="checklist">
            <li>Atualização em tempo real nas listas compartilhadas.</li>
            <li>Total da compra sempre visível enquanto você marca os itens.</li>
            <li>Modo claro e escuro, sem recarregar a página.</li>
          </ul>
        </section>

        <section className="surface-card card-pad auth-card">
          <div className="section-heading__text">
            <span className="eyebrow">Login</span>
            <h2 className="section-subtitle">Acesse sua conta</h2>
          </div>

          {sessionMessage && (
            <p className="notice notice--info" role="status">
              {sessionMessage}
            </p>
          )}

          {successMessage && (
            <p className="notice notice--success" role="status">
              {successMessage}
            </p>
          )}

          {errorMessage && (
            <p className="notice notice--error" role="alert">
              {errorMessage}
            </p>
          )}

          <form onSubmit={onSubmit} className="field-form">
            <div className="field">
              <label className="field-label" htmlFor="email">
                E-mail
              </label>
              <input
                id="email"
                type="email"
                className="input"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="email"
                inputMode="email"
                required
                autoFocus
              />
            </div>

            <PasswordInput
              id="senha"
              label="Senha"
              value={senha}
              onChange={(event) => setSenha(event.target.value)}
              autoComplete="current-password"
              required
            />

            <button type="submit" className="btn btn--primary btn--block" disabled={isPending}>
              {isPending ? <Spinner label="Entrando..." /> : 'Entrar'}
            </button>
          </form>

          <p className="auth-footer">
            Não tem uma conta?{' '}
            <Link to="/register" className="link-inline">
              Crie agora
            </Link>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Login;
